import { useGetIdentity, useGetList } from "ra-core";

import { canAccess } from "../providers/commons/canAccess";
import type { AppRole, QuoterPlanApprover } from "../types";

export type PlanDeciderState = "loading" | "allowed" | "denied";

/**
 * Almikia batch EQ3 (TASK-115): may the current identity open "Planes por aprobar"? Direccion
 * always; any other quoting role only when she holds an ACTIVE approver row (the table is readable
 * by the approver herself). An identity without a role is denied. This is cosmetic: the approve /
 * reject RPCs re-check it in SQL.
 */
export const useCanDecidePlans = (): PlanDeciderState => {
  const { identity, isPending } = useGetIdentity();
  const role = identity?.role as AppRole | undefined;
  const isQuoting =
    role != null &&
    canAccess(role, { resource: "quoter_plan_approvals", action: "list" });
  const checksRow = isQuoting && role !== "direccion" && identity?.id != null;
  const row = useGetList<QuoterPlanApprover>(
    "quoter_plan_approvers",
    {
      filter: { sales_id: identity?.id },
      pagination: { page: 1, perPage: 1 },
    },
    { enabled: checksRow },
  );

  if (isPending) return "loading";
  if (!isQuoting) return "denied";
  if (role === "direccion") return "allowed";
  if (!checksRow) return "denied";
  if (row.isPending) return "loading";
  return row.data?.some((approver) => approver.active) ? "allowed" : "denied";
};
